import { useEffect, useState } from "react";
import "../../css/mail.css";
import "../../css/formulaire.css";
// import "../../css/mailResponsive.css";

import EnvoyerMail from "../../components/Envoyer_mail";
import MailEnvoye from "../../components/Mail_envoyer";
import LoaderAnnonce from "../../components/LoaderAnnonce";
import MailEnvoyeClient from "../../components/MailEnvoyerClient";
import EnvoyerMailClient from "../../components/EnvoyerMailClient";
import GestionQuota from "../../components/GestionQuota";
import { isUserHaveAnnonce } from "../../services/Annonce_service";
import { useLocation } from "react-router-dom";
import ContactModal from "../client/ContactModal"; 
import { ToastContainer } from "react-toastify";
import { Alert } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { trackMenuClick } from "../../services/menuClick_service";

function GestionEmail() {
  const [activeTab, setActiveTab] = useState<string>("EnvoyerMail");
  const [loading, setLoading] = useState<boolean>(false);
  const [role, setRole] = useState<string | null>(null);
  const [userType, setUserType] = useState<string | null>(null);
  const [isEntreprise, setIsEntreprise] = useState<boolean>(false);
  const [alreadyHaveAnnonce, setAlreadyHaveAnnonce] = useState<boolean>(false);
  const [emailAutorized, setEmailAutorized] = useState<boolean>(true);
  const [mount, setMount] = useState<boolean>(false);
  const location = useLocation();
  const userStatus = localStorage.getItem("userStatus") || "anonymous";

  const [isContactModalVisible, setIsContactModalVisible] = useState(false);

  const openContactModal = () => {
    trackMenuClick('email-support-contact', 'Contacter le support - Email');
    setIsContactModalVisible(true);
  };
  
  const closeContactModal = () => setIsContactModalVisible(false);

  const updateTab = (active: string, tabName: string) => {
    // Tracker le changement d'onglet
    trackMenuClick(`email-tab-${active}`, `Onglet ${tabName}`);
    setLoading(true);
    setActiveTab(active);
    setTimeout(() => setLoading(false), 500);
  };

  useEffect(() => {
    const storedEmailAutorized = localStorage.getItem("email_autorized");
    if (storedEmailAutorized !== null) {
      setEmailAutorized(JSON.parse(storedEmailAutorized));
    }
  }, []);

  const renderContent = () => {
    // Affiche le message si userType = personne, role = CLIENT et isEntreprise = false
    if (userType === "personne" && role === "CLIENT" && !isEntreprise) {
      return (
        <div className="alert-message">
          <span>
            Pour bénéficier de ce module, il faut que vous soyez en compte entreprise ou professionnel, vous pouvez mettre à jour votre compte dans Gestion de mon compte.
          </span>
        </div>
      );
    }

    switch (activeTab) {
      case "boite":
        return role === "ADMIN" ? <MailEnvoye /> : <MailEnvoyeClient />;

      case "EnvoyerMail":
        return role === "ADMIN" ? (
          <EnvoyerMail />
        ) : !emailAutorized ? (
          <div className="access-alert access-alert--restricted">
            <div className="access-alert__icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="#F4A261"/>
              </svg>
            </div>
            <div className="access-alert__content">
              <h3 className="access-alert__title">Envoi d'emails désactivé</h3>
              <p className="access-alert__message">
                L'autorisation d'envoi d'emails est désactivée sur votre compte.
                Contactez le support pour l'activer.
              </p>
              <button
                type="button"
                className="access-alert__action"
                onClick={openContactModal}
              >
                Contacter le support
              </button>
            </div>
          </div>
        ) : !alreadyHaveAnnonce ? (
          <div className="access-alert access-alert--info">
            <div className="access-alert__icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z" fill="#2196F3"/>
              </svg>
            </div>
            <div className="access-alert__content">
              <h3 className="access-alert__title">Annonce requise</h3>
              <p className="access-alert__message">
                Publiez votre première annonce pour débloquer l'envoi d'emails.
              </p>
              <button 
                onClick={() => {
                  trackMenuClick('email-publish-annonce', 'Publier une annonce depuis email');
                  window.location.href = '/nouvelle-annonce';
                }} 
                className="access-alert__action access-alert__action--primary"
              >
                Publier une annonce
              </button>
            </div>
          </div>
        ) : (
          <EnvoyerMailClient />
        );

      case "Gestionquota":
        return role === "ADMIN" ? <GestionQuota /> : null;
      default:
        return null;
    }
  };

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    const storedUserType = localStorage.getItem("userType");
    const storedIsEntreprise = localStorage.getItem("isEntreprise");

    if (storedRole) setRole(storedRole);
    if (storedUserType) setUserType(storedUserType);
    if (storedIsEntreprise) setIsEntreprise(JSON.parse(storedIsEntreprise));
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams.get("tab");
    if (tabParam && ["boite", "EnvoyerMail", "Gestionquota"].includes(tabParam)) {
      setActiveTab(tabParam);
    }
  }, [location]);

  useEffect(() => {
    if (!mount) {
      isUserHaveAnnonce().then((response) => {
        setAlreadyHaveAnnonce(response?.alreadyHaveAnnonce || false);
        setMount(true);
      });
    }
  }, [mount]);

  if (loading) {
    return <LoaderAnnonce />;
  }

  if (userStatus === "anonymous") {
    return (
      <>
        <ToastContainer />
        <div className="gp-root container-fluid">
          <div className="mt-5 text-center">
            <Alert
              className="custom-alert-white"
              message="Module de gestion des emails indisponible"
              description="Ravi de vous compter parmi nous ! Publiez votre première annonce et finalisez votre inscription pour profiter de ce module."
              type="warning"
              showIcon
              icon={<ExclamationCircleFilled style={{ color: '#eb8635' }} />}
              style={{
                fontSize: '1.1rem',
              }}
            />
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="container-fluid px-2 px-md-3">
      <div className="mb-3 mb-md-4">
        <ul className="nav nav-underline">
          {role === "CLIENT" ? (
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab === "EnvoyerMail" ? "active" : ""}`}
                onClick={() => updateTab("EnvoyerMail", "Messagerie & Suivi")}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    updateTab("EnvoyerMail", "Messagerie & Suivi");
                  }
                }}
              >
                Messagerie & Suivi
              </a>
            </li>
          ) : (
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab === "EnvoyerMail" ? "active" : ""}`}
                onClick={() => updateTab("EnvoyerMail", "Envoyer un email")}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    updateTab("EnvoyerMail", "Envoyer un email");
                  }
                }}
              >
                Envoyer un email
              </a>
            </li>
          )}
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === "boite" ? "active" : ""}`}
              onClick={() => updateTab("boite", "Boîte d'envoi")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  updateTab("boite", "Boîte d'envoi");
                }
              }}
            >
              Boîte d'envoi
            </a>
          </li>
          {role === "ADMIN" && (
            <li className="nav-item">
              <a
                className={`nav-link ${activeTab === "Gestionquota" ? "active" : ""}`}
                onClick={() => updateTab("Gestionquota", "Gestion de Quotas")}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    updateTab("Gestionquota", "Gestion de Quotas");
                  }
                }}
              >
                Gestion de Quotas
              </a>
            </li>
          )}
        </ul>
      </div>

      <ContactModal
        show={isContactModalVisible}
        onClose={closeContactModal}
      />
      <div className="mt-3 mt-md-4">
        {mount && renderContent()}
      </div>
    </div>
  );
}

export default GestionEmail;